(function() { window.GUID_504bfb47_3ef6_4890_acd7_e76a3801c015 = { getGuid: function() { return "504bfb47-3ef6-4890-acd7-e76a3801c015"; } }; })();
var RejectedReason;
(function (RejectedReason) {
    var desktop;
    (function (desktop) {
        let gridViewPendingScoreSheetsUI = $('#GridViewPendingScoreSheets');
        let gridViewPendingScoreSheets = gridViewPendingScoreSheetsUI.data('context');
        let gridViewSchedulesUI = $('#GridViewSchedules');
        let gridViewSchedules = gridViewSchedulesUI.data('context');
        CS.body.on('Refreshed', '#GridViewSchedules', function (e, gridView) {
            gridViewSchedules = gridView;
        });
        CS.body.on('Refreshed', '#GridViewPendingScoreSheets', function (e, gridView) {
            gridViewPendingScoreSheets = gridView;
        });
        CS.FormReady(function (formId) {
            if (formId == "RejectedReason") {
                var rejectedReason = $('#rejectedReason');
                //Ici, j'évite que la touche Enter post le formulaire
                rejectedReason.on('keypress', function (e) {
                    e.stopPropagation();
                });
            }
        });
        function RejectedReasonPopup(formDialog) {
            var encounterRowId = $('#encounterRowId').val();
            formDialog.dialog("close");
            var ElementToRefreshName = $('#elementToRefresh').val();
            var ElementToRefresh = null;
            if (ElementToRefreshName == 'GridViewPendingScoreSheets') {
                ElementToRefresh = gridViewPendingScoreSheets;
            }
            else {
                ElementToRefresh = gridViewSchedules;
            }
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "RejectedReasonPopup",
                Url: CSParameters.RUrl + 'Scores/ScorePopupRejected/' + CSParameters.SportEventId,
                Data: { encounterRowId: encounterRowId, elementToRefresh: ElementToRefreshName },
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            ElementToRefresh.RefreshGridData();
            /*
            ShowFormPopup(CSParameters.RUrl + 'Scores/ScorePopupRejected/' + CSParameters.SportEventId + '?encounterRowId=' + encounterRowId + '&elementToRefresh=' + ElementToRefreshName, null, ElementToRefresh, function () {
    
                $(this).dialog("close");
            });
            */
        }
    })(desktop = RejectedReason.desktop || (RejectedReason.desktop = {}));
})(RejectedReason || (RejectedReason = {}));

//# sourceMappingURL=RejectedReason.desktop.js.map
